import { useTranslations } from "next-intl";
import { useMemo } from "react";

import IconPao from "@/icons/icon-pao";
import IconUvProtection from "@/icons/icon-uv-protection";
import IconWaterproof from "@/icons/icon-waterproof";
import IconWeight from "@/icons/icon-weight";
import CrossCountry from "~/types/cross-country";
import iconPaths from "~/utils/icon-paths";

import Icon from "../common/icon";
import styles from "./product-services-icons.module.scss";

type Props = {
  selectedShade: CrossCountry.DetailedProduct;
};

export default function ProductServicesIcons(props: Props) {
  const t = useTranslations();

  const countryOfOrigin = props.selectedShade?.country_of_origin;

  const madeIn =
    countryOfOrigin && Object.keys(iconPaths).includes(`made-in-${countryOfOrigin}`)
      ? (`made-in-${countryOfOrigin}` as keyof typeof iconPaths)
      : undefined;

  const legalVolume = useMemo(() => {
    if (props.selectedShade) {
      if (props.selectedShade.legal_volume && props.selectedShade.legal_volume > 0) {
        const floz = (props.selectedShade.legal_volume / 29.57353).toFixed(3);
        return props.selectedShade.legal_volume + " ml / " + floz + " fl.oz";
      } else if (props.selectedShade.legal_weight && props.selectedShade.legal_weight > 0) {
        const oz = (props.selectedShade.legal_weight / 28.34955).toFixed(3);
        return props.selectedShade.legal_weight + " gr / " + oz + " oz";
      }
      return null;
    }
  }, [props.selectedShade]);

  return (
    <div className={styles.serviceGrid}>
      {legalVolume && (
        <div className={styles.serviceItem}>
          <Icon icon={IconWeight} aria-hidden />
          <span>{legalVolume}</span>
        </div>
      )}
      {countryOfOrigin && (
        <div className={styles.serviceItem}>
          <>
            {madeIn && <Icon name={madeIn} aria-hidden />}
            <span>{t(`generic.madeIn${countryOfOrigin}`)}</span>
          </>
        </div>
      )}
      {props.selectedShade?.pao && props.selectedShade?.pao != "0" && (
        <div className={styles.serviceItem}>
          <Icon icon={IconPao} aria-hidden />
          <span>{t("generic.pao", { 0: props.selectedShade?.pao })}</span>
        </div>
      )}
      {props.selectedShade.water_resistent && (
        <div className={styles.serviceItem}>
          <Icon icon={IconWaterproof} aria-hidden />
          <span>{t("generic.waterproof")}</span>
        </div>
      )}
      {props.selectedShade?.protection_level && !isNaN(props.selectedShade.protection_level as unknown as number) && (
        <div className={styles.serviceItem}>
          <Icon icon={IconUvProtection} aria-hidden />
          <span>SPF {props.selectedShade.protection_level}</span>
        </div>
      )}
    </div>
  );
}
